var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n\n<li>\n  <i class="ra ra-circle legend-home-insurance icon-space-right"></i> Home Insurance\n  <div class="float-right editinplace-trigger display-inline">\n    <input type="text" data-rate="'+
((__t=( mortgageData.insurance_rate ))==null?'':__t)+
'" value="'+
((__t=( mortgageData.monthly_home_insurance ))==null?'':__t)+
'" class="input-no-style input-edit-inplace payment_option_fields" id="home_insurance" maxlength="8" size="8"/>\n  </div>\n</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/insurance.jst.ejs